<template>
     <div class="PasswordChangeView">
          <PasswordChangeCmp />
     </div>
</template>
<script>
     import PasswordChangeCmp from "@/components/PasswordChangeCmp.vue";

     export default {
          name      : "PasswordChangeView",
          components: {
               PasswordChangeCmp
          }
     };
</script>